import { Col, Flex, Row, Typography } from "antd";
import dayjs from "dayjs";

export default function QuestionContentPreview(props) {
	const {
		id = [],
		question = null,
		description = null,
		type = null,
		form_question_options = [],
		answers = {},
	} = props;

	// console.log("QuestionContentPreview props:", props);

	const renderQuestionOption = () => {
		let newId = Array.isArray(id) ? id.join("_") : id;

		switch (type) {
			case "Text (Input)":
			case "Number (Input)":
			case "Date (Datepicker)":
			case "Time (Timepicker)":
			case "Radio (Button)":
			case "Checkbox":
			case "Select (Dropdown)":
				let answer = [];

				Object.keys(answers).forEach((key) => {
					if (!key.includes("_other")) {
						// console.log("renderQuestionOption answers: ", answers);
						// console.log("renderQuestionOption key: ", key);
						// console.log("renderQuestionOption newId: ", newId);
						// console.log("renderQuestionOption answers[key]: ", answers[key]);

						if (answers[key] && answers[key] !== undefined) {
							// let keyParts = key.split("_");
							// console.log("renderQuestionOption keyParts: ", keyParts);

							// console.log(
							// 	"renderQuestionOption answers[key], newId: ",
							// 	key,
							// 	newId,
							// );

							if (key === newId) {
								answer.push(checkTypeAnswer(type, answers[key]));
								// console.log("renderQuestionOption answer - 1: ", answer);
							} else if (key.startsWith(`${newId}_qo_`)) {
								answer.push(checkTypeAnswer(type, answers[key]));
								// console.log("renderQuestionOption answer - 2: ", answer);
							}
						} else {
							if (answers[key]) {
								answer.push(checkTypeAnswer(type, answers[key]));
							}
						}
					} else if (key.includes("_other")) {
						// console.log("renderQuestionOption answers - 2: ", answers);
						// console.log("renderQuestionOption key - 2: ", key);
						// console.log("renderQuestionOption newId - 2: ", newId);
						// console.log(
						// 	"renderQuestionOption answers[key] - 2: ",
						// 	answers[key],
						// );

						if (answers[key] && answers[key] !== undefined) {
							let q_id = key.split("_other")[0];
							if (q_id === newId) {
								answer.push(": " + answers[key]);
							}
						} else {
							if (answers[key]) {
								answer.push(": " + answers[key]);
							}
						}
					}
				});

				// console.log("renderQuestionOption answer: ", answer);

				let extractSubAnswerCopy = extractSubAnswer(
					type,
					newId,
					form_question_options,
				);

				const indexedSubOptionAnswers = extractIndexedSubOptionAnswers(
					type,
					newId,
					form_question_options,
				);

				if (extractSubAnswerCopy !== null && extractSubAnswerCopy.length > 0) {
					answer.push(...extractSubAnswerCopy);
				}

				if (indexedSubOptionAnswers.length > 0) {
					answer.push(...indexedSubOptionAnswers);
				}

				const normalizedAnswer = answer
					.flat(Infinity)
					.filter((item) => item !== null && item !== undefined && item !== "");

				let extractSubAnswerWithSubQuestionCopy =
					extractSubAnswerWithSubQuestion(type, newId, form_question_options);

				// console.log("renderQuestionOption answersss: ", answer);

				return (
					<Flex vertical>
						{extractSubAnswerWithSubQuestionCopy}
						<Flex vertical style={{ paddingLeft: 20 }}>
							{normalizedAnswer.map((item, index) => (
								<Flex key={index}>- {item}</Flex>
							))}
						</Flex>
					</Flex>
				);
			case "sub_question":
				return (
					<Row gutter={[20, 20]}>
						<Col xs={24} sm={24} md={24} lg={24} xl={24}></Col>
						<Col xs={24} sm={24} md={24} lg={24} xl={24}>
							{/* {console.log("renderQuestionOption option111 answers: ", answers)} */}
							{form_question_options.map((option, index) => {
								// console.log(
								// 	"renderQuestionOption option111 answerId: ",
								// 	`q_${option.form_question_id}_set_${index}`,
								// );

								// console.log("renderQuestionOption option111 option: ", option);
								return (
									<Row key={`${newId}_qo_${option.id}`}>
										<Col xs={24} sm={24} lg={24} xl={24} xxl={24}>
											<Flex align="center" gap={5}>
												<Typography.Text strong>
													{option.option}
												</Typography.Text>
												{option.option_required ? (
													<>
														<Typography.Text strong>: </Typography.Text>
														<Typography.Text>
															{
																answers[
																	`q_${option.form_question_id}_set_${index}`
																]
															}
														</Typography.Text>
													</>
												) : (
													<>
														<Typography.Text strong>: </Typography.Text>
														<Typography.Text>
															{
																answers[
																	`q_${option.form_question_id}_set_${index}`
																]
															}
														</Typography.Text>
													</>
												)}
											</Flex>
										</Col>
										<Col xs={24} sm={24} lg={24} xl={24} xxl={24}>
											<QuestionContentPreview
												id={[...id, `qo_${option.id}`]}
												question={option.question_option}
												type={option.sub_option_type}
												form_question_options={
													option.form_question_options.length
														? option.form_question_options
														: []
												}
												answers={answers}
											/>
										</Col>
									</Row>
								);
							})}
						</Col>
					</Row>
				);
			default:
				return null;
		}
	};

	const extractIndexedSubOptionAnswers = (type, id, form_question_options) => {
		const visibleOptions = form_question_options.filter((x) => !x.is_other);
		const indexedSubAnswers = [];

		Object.keys(answers).forEach((key) => {
			const keyPattern = new RegExp(`^${id}_option_(\\d+)_sub_option_(\\d+)$`);
			const match = key.match(keyPattern);

			if (!match || !hasAnswerValue(answers[key])) {
				return;
			}

			const optionIndex = Number(match[1]);
			const subOptionIndex = Number(match[2]);
			const option = visibleOptions[optionIndex];
			const subOptions = (option?.form_question_options || []).filter(
				(x) => !x.is_other,
			);
			const subOption = subOptions[subOptionIndex];

			const formattedAnswer = checkTypeAnswer(type, answers[key]);

			if (!hasAnswerValue(formattedAnswer)) {
				return;
			}

			const labelParts = [option?.option, subOption?.option].filter(Boolean);

			if (labelParts.length) {
				indexedSubAnswers.push(`${labelParts.join(" - ")}: ${formattedAnswer}`);
				return;
			}

			indexedSubAnswers.push(formattedAnswer);
		});

		return indexedSubAnswers;
	};

	const extractSubAnswer = (type, id, form_question_options) => {
		switch (type) {
			case "Text (Input)":
			case "Number (Input)":
			case "Select (Dropdown)":
			case "Date (Datepicker)":
			case "Time (Timepicker)":
			case "Radio (Button)":
			case "Checkbox":
				let answer = [];

				form_question_options.forEach((option) => {
					let subanswer = answers[`${id}_qo_${option.id}`];

					if (option.sub_option_type) {
						if (subanswer) {
							answer.push(checkTypeAnswer(option.sub_option_type, subanswer));
						}
						let extractSubAnswerCopy = extractSubAnswer(
							option.sub_option_type,
							`${id}_qo_${option.id}`,
							option.form_question_options,
						);

						if (extractSubAnswerCopy) {
							answer.push(...extractSubAnswerCopy);
						}
					}
				});

				return answer;
			default:
				return null;
		}
	};
	const extractSubAnswerWithSubQuestion = (type, id, form_question_options) => {
		switch (type) {
			case "sub_question":
				return form_question_options.map((option) => {
					return (
						<Row key={`${id}_qo_${option.id}`}>
							<Col xs={24} sm={24} lg={24} xl={24} xxl={24}>
								<Typography.Text strong>{option.option}</Typography.Text>
							</Col>
							<Col xs={24} sm={24} lg={24} xl={24} xxl={24}>
								<QuestionContentPreview
									id={[...id, `qo_${option.id}`]}
									question={option.question_option}
									type={option.sub_option_type}
									form_question_options={
										option.form_question_options.length
											? option.form_question_options
											: []
									}
									answers={answers}
								/>
							</Col>
						</Row>
					);
				});
			default:
				return null;
		}
	};

	const checkTypeAnswer = (type, answer) => {
		switch (type) {
			case "Text (Input)":
			case "Number (Input)":
			case "Select (Dropdown)":
			case "Radio (Button)":
				return Array.isArray(answer) ? answer.join(", ") : answer;
			case "Date (Datepicker)":
				return answer ? dayjs(answer).format("MM/DD/YYYY") : null;
			case "Time (Timepicker)":
				return answer ? dayjs(answer).format("HH:mm:ss") : null;
			case "Checkbox":
				return answer.join(", ");
			default:
				return null;
		}
	};

	const hasAnswerValue = (value) => {
		if (value === undefined || value === null || value === "") {
			return false;
		}

		if (Array.isArray(value)) {
			return value.length > 0;
		}

		return true;
	};

	return (
		<Row>
			{question ? (
				<Col xs={24} sm={24} md={24} lg={24} xl={24}>
					<div
						className="quill-output question"
						dangerouslySetInnerHTML={{
							__html: question,
						}}
					/>
					{description && <div className="description">{description}</div>}
				</Col>
			) : null}

			<Col
				xs={24}
				sm={24}
				md={24}
				lg={24}
				xl={24}
				style={Array.isArray(id) ? { paddingLeft: 20 } : {}}
			>
				{renderQuestionOption()}
			</Col>
		</Row>
	);
}
